import { Star } from 'lucide-react';

/** Maps 0–100 fitment to 0–5 filled stars for quick visual scan. */
export function FitmentStarRating({ score, className = '' }: { score: number; className?: string }) {
  const filled = Math.max(0, Math.min(5, Math.round((score / 100) * 5)));
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} title={`Fitment ${score}/100`}>
      {Array.from({ length: 5 }, (_, i) => (
        <Star
          key={i}
          className={`h-3.5 w-3.5 ${i < filled ? 'fill-amber-400 text-amber-400' : 'text-gray-600'}`}
          strokeWidth={i < filled ? 0 : 1.5}
        />
      ))}
    </div>
  );
}
